<template>
  <div class="event-info flex flex-col justify-start items-center mt-8 mb-8">
    <img
      :src="getImageUrl(event)"
      class="lazyload w-full object-cover w-full h-auto"
      alt="userProfile"
      @error="
        $event.target.src = require('@/assets/images/placeholder-event.svg')
      "
    />
    <div class="flex flex-col items-center w-full">
      <div class="flex flex-col w-10/12">
        <h2 :style="getPersonalizedTitle" class="my-8">
          {{ event.title }}
        </h2>
        <h3 :style="getPersonalizedSubtitle" class="topaz">
          {{ event.venue?.name }}
        </h3>
        <span :style="getPersonalizedSubtitle" class="subtitle">{{
          event.venue?.address
        }}</span>
        <h3
          v-if="!event.hide_start_date_on_ticket_office"
          :style="getPersonalizedSubtitle"
          class="my-8 "
        >
          {{ formatDate(event.start_date, selectedRegion()) }}
        </h3>
        <h3
          v-if="event.hide_start_date_on_ticket_office" 
          :style="getPersonalizedSubtitle"
          class="my-8 "
        >
        </h3>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useEvent } from "@/composables/useEvent";
import { useIframeStyle } from "@/composables/useIframeStyle";
import { useUser } from "@/composables/useUser";

import { formatLongDate } from "@/plugins/date-formater";
import { watch } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const { userDetail, selectedRegion } = useUser();
const formatDate = (date, region) => {
  let infoDate = formatLongDate(date, region, event.value.attendance === 2);
  return t("wegow.date.dateFormat", infoDate);
};

const { details: event } = useEvent();
const { getPersonalizedTitle, getPersonalizedSubtitle } = useIframeStyle();
watch (
  () => {
    if (event.value) {
      getPersonalizedTitle.value = event.value.personalized_title;
      getPersonalizedSubtitle.value = event.value.personalized_subtitle;
    }
  },
  { immediate: true }
);
const getImageUrl = element => {
  return element?.thumbnails?.l_hor_dt
    ? element.thumbnails.l_hor_dt
    : element?.image_url;
};
</script>

<style lang="scss" scoped>
.event-info {
  & > div {
    background-color: #1c1d29;
    h2 {
      font-weight: 600;
      font-size: 35px;
      line-height: 42px;
    }
    h3 {
      font-weight: 400;
      font-size: 25px;
      line-height: 30px;
    }
    .topaz {
      color: $topaz;
    }
    .subtitle {
      font-weight: 400;
      font-size: 15px;
      line-height: 20px;
      color: $textSubtitle;
    }
  }
}
</style>
